import { ErrorBoundary } from "@/components/common/ErrorBoundary";
import { Footer } from "@/components/common/Footer";
import { Header } from "@/components/common/Header";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

export function AppLayout() {
	const { t } = useTranslation();

	return (
		<div className="flex min-h-screen flex-col bg-bg-base">
			<a href="#main-content" className="skip-to-content">
				{t("nav.skipToContent")}
			</a>
			<Header />
			<main id="main-content" className="flex-1 page-enter">
				<ErrorBoundary>
					<Outlet />
				</ErrorBoundary>
			</main>
			<Footer />
		</div>
	);
}
